import { useTranslation } from "@/Common/CustomHooks/useTranslation";

import styles from "./NotUsingRolePermissionsWarningComponent.module.scss";

import MedfarWarningSolo from "@/DesignSystem/Atoms/Icons/Types/MedfarWarningSolo/medfar-warning-solo.svg";

function NotUsingRolePermissionsWarningComponent(): JSX.Element {
    const { getText } = useTranslation();
    return (
        <div className={styles.warningWrapper}>
            <div className={styles.warningIconWrapper}>
                <MedfarWarningSolo fill="white" />
            </div>
            <span>{getText("RoleBasedAccessControl_NotUsingRoleBasedPermissionsWarning")}
            </span>
        </div>
    );
}

export { NotUsingRolePermissionsWarningComponent };
